import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { useLocale, useT } from "../../i18n";
import { countryList, useTaxonomies } from "../../lib/taxonomies";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "../ui/command";
import { INPUT } from "./FormKit";

// Searchable country picker backed by the countries taxonomy (stores ISO alpha-2 codes).
export const CountrySelect = ({ id, value, onChange, exclude = [], testId, invalid }) => {
  const t = useT();
  const lang = useLocale();
  const [tx] = useTaxonomies();
  const [open, setOpen] = useState(false);
  const rows = countryList(tx, lang).filter((c) => !exclude.includes(c.code));
  const current = rows.find((c) => c.code === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger id={id} type="button" aria-invalid={invalid || undefined} data-testid={testId}
        className={`${INPUT} flex h-12 items-center justify-between text-left`}>
        <span className={current ? "" : "text-ink/40"}>{current?.name || t("form.selectCountry")}</span>
        <ChevronDown size={16} strokeWidth={1.25} className="shrink-0 opacity-60" />
      </PopoverTrigger>
      <PopoverContent align="start" className="z-[80] w-[var(--radix-popover-trigger-width)] rounded-none p-0">
        <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder={t("form.searchCountry")} data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>{t("form.noCountry")}</CommandEmpty>
            {rows.map((c) => (
              <CommandItem key={c.code} value={`${c.name} ${c.code}`} onSelect={() => { onChange(c.code); setOpen(false); }}
                data-testid={`${testId}-option-${c.code}`} className="min-h-[40px] rounded-none">
                <Check size={14} className={c.code === value ? "opacity-100" : "opacity-0"} />
                {c.name}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
